<template>
    <div class="container-fluid">
        <Loading v-if="!loaded"></Loading>
        <div v-else>
            <!-- TITLE -->
            <div class="mt-2 tabName">
                <h3 v-if="Object.keys(log).length !== 0">
                    {{ $t('edit_log') }}: {{ $t(log.action) }} ({{
                        getLocalDate(log.created_at, $i18n.locale, true, true)
                    }})
                </h3>
                <h3 v-else>{{ $t('edit_log') }}</h3>
            </div>
            <!-- LOG FIELDS -->
            <div class="row mt-4">
                <div class="col-sm-10 col-md-9 col-lg-8 col-xl-7">
                    <ValidationObserver v-slot="{ handleSubmit }">
                        <form role="form" @submit.prevent="handleSubmit(submit)">
                            <!-- CLIENT -->
                            <div
                                class="form-group"
                                v-if="
                                    log.type.match(/^(reservation|take_out)$/) && !log.action.match(/^(alarm|report)$/)
                                "
                            >
                                <ValidationProvider name="client" v-slot="{ errors }">
                                    <label for="clientInput">{{ $t('client') }}</label>
                                    <input
                                        type="text"
                                        id="clientInput"
                                        class="form-control"
                                        v-model="clientCorrected"
                                    />
                                    <div class="invalid-feedback" style="display: block">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <!-- DOCTOR -->
                            <div
                                class="form-group"
                                v-if="
                                    log.type.match(/^(reservation|take_out)$/) && !log.action.match(/^(alarm|report)$/)
                                "
                            >
                                <ValidationProvider name="doctor" v-slot="{ errors }">
                                    <label for="doctorInput">{{ $t('doctor') }}</label>
                                    <input
                                        type="text"
                                        id="doctorInput"
                                        class="form-control"
                                        v-model="doctorCorrected"
                                    />
                                    <div class="invalid-feedback" style="display: block">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <!-- PRESCRIPTION -->
                            <div
                                class="form-group"
                                v-if="
                                    log.type.match(/^(reservation|take_out)$/) && !log.action.match(/^(alarm|report)$/)
                                "
                            >
                                <ValidationProvider name="prescription" v-slot="{ errors }">
                                    <label for="prescriptionInput">{{ $t('prescription') }}</label>
                                    <input
                                        type="text"
                                        id="prescriptionInput"
                                        class="form-control"
                                        v-model="prescriptionCorrected"
                                    />
                                    <div class="invalid-feedback" style="display: block">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <!-- PUT IN CHANGE SUPPLIER -->
                            <div
                                class="form-group"
                                v-if="
                                    log.type.match(/^(put_in)$/) && !log.action.match(/^(alarm|report)$/)
                                "
                            >
                                <ValidationProvider name="reSupplier" v-slot="{ errors }">
                                    <label for="reSupplierInput">{{ $t('supplier') }} ({{supplier}})</label>
                                    <input
                                        type="text"
                                        id="reSupplierInput"
                                        class="form-control"
                                        v-model="reSupplier"
                                    />
                                    <div class="invalid-feedback" style="display: block">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <!-- COMMENTS -->
                            <div class="form-group">
                                <label for="commentsInput">{{ $t('comments') }}</label>
                                <textarea
                                    v-if="commentsPrev"
                                    type="text"
                                    class="form-control"
                                    disabled
                                    v-model="commentsPrev"
                                />
                                <ValidationProvider name="comments" v-slot="{ errors }">
                                    <textarea type="text" id="commentsInput" class="form-control" v-model="comments" />
                                    <div class="invalid-feedback" style="display: block">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <!-- BUTTONS: SUBMIT, CANCEL -->
                            <div class="d-flex flex-row">
                                <div class="d-flex flex-column mr-3">
                                    <input
                                        type="submit"
                                        class="btn btn-md btn-success"
                                        :disabled="submitClicked"
                                        :value="$t('save')"
                                    />
                                </div>
                                <div class="d-flex flex-column">
                                    <input
                                        type="button"
                                        @click="returnToPreviousPage"
                                        class="btn btn-secondary"
                                        :value="$t('cancel')"
                                        :disabled="submitClicked"
                                    />
                                </div>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
                <div class="col-sm-2 col-md-3 col-lg-4 col-xl-5" v-if="log.action == 'take_out'">
                    <h5>
                        {{ $t('take_out_action_may_be_destroy_of_medication') }}
                    </h5>
                    <div class="form-group">
                        <label>{{ $t('comments_to_destroyed_drugs') }}</label>
                        <hr>
                        <p>{{ $t('i_give_consent_that_i_mark_action_as_destroy') }}</p>
                        <div class="d-flex flex-row">
                            <div class="d-flex flex-column mr-3">
                                <input
                                    type="button"
                                    class="btn btn-md btn-danger"
                                    @click="handleMarkLogClick"
                                    :disabled="submitClicked"
                                    :value="$t('update_and_sign')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL: ARE YOU SURE YOU WANT TO MARK LOG AS DESTROYED? -->
        <b-modal id="markConfirmationModal" centered :title="$t('mark_log_as_destroyed_title')" hide-footer>
            <div class="row">
                <div class="col">
                    <p>{{ $t('mark_log_as_destroyed_question') }}</p>
                </div>
            </div>
            <div class="d-flex row mt-2">
                <div class="d-flex col justify-content-center">
                    <button class="btn btn-danger mr-4" @click="markLogAsDestroyed">
                        {{ $t('yes') }}
                    </button>
                    <button class="btn btn-secondary" @click="handleMarkLogCancel">
                        {{ $t('no') }}
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Loading from '@/views/partial/Loading';
import { getLog, handleAxiosError, updateLog } from '@/services/axiosService';
import { getLocalDate } from '@/services/dateService';
import { getAllLogFieldValues, getLatestLogFieldValue } from '@/services/logService';

export default {
    components: { Loading },
    data() {
        return {
            client: '',
            clientCorrected: '',
            doctor: '',
            doctorCorrected: '',
            prescription: '',
            prescriptionCorrected: '',
            supplier: '',
            reSupplier: '',
            comments: '',
            error: false,
            from: '',
            getAllLogFieldValues,
            getLatestLogFieldValue,
            getLocalDate,
            loaded: false,
            log: {},
            submitClicked: false
        };
    },
    // save previous page name for routing
    beforeRouteEnter(_to, from, next) {
        next(vm => {
            vm.from = from.name;
        });
        next();
    },
    async created() {
        // get log info
        await this.getLog();
        if (!this.error) {
            this.loaded = true;
        }
    },
    computed: {
        ...mapState('account', ['user']),
        commentsPrev() {
            return this.getAllLogFieldValues(this.log.comments, true);
        }
    },
    methods: {
        // get log
        async getLog() {
            try {
                const logId = this.$route.params.id;
                this.log = await getLog(this.user.pharmacy_id, logId);
                if (this.log.type.match(/^(reservation|take_out)$/) && this.log.action !== 'report') {
                    this.client = this.getLatestLogFieldValue(this.log.client, false);
                    this.clientCorrected = this.client;
                    this.doctor = this.getLatestLogFieldValue(this.log.doctor, false);
                    this.doctorCorrected = this.doctor;
                    this.prescription = this.getLatestLogFieldValue(this.log.prescription, false);
                    this.prescriptionCorrected = this.prescription;
                }
                if (this.log.type.match(/^(put_in)$/) && this.log.action !== 'report' && this.log.action !== 'alarm') {
                    this.supplier = this.log.supplier;
                    this.reSupplier = this.getLatestLogFieldValue(this.log.re_supplier, false);
                }
                this.log.id = logId;
            } catch (error) {
                handleAxiosError(error);
                this.error = true;
            }
        },
        // return to previous page (if logs index, retain previously used logs table filtering parameters)
        returnToPreviousPage() {
            if (this.from === 'logs.index') {
                this.$router.push({ name: this.from, params: { filterParams: this.$route.params.filterParams } });
            } else {
                this.$router.go(-1);
            }
        },
        // submit form
        async submit() {
            try {
                this.submitClicked = true;
                // trim editable fields before submit
                this.comments = this.comments.trim();
                this.clientCorrected = this.clientCorrected.trim();
                this.doctorCorrected = this.doctorCorrected.trim();
                this.prescriptionCorrected = this.prescriptionCorrected.trim();
                this.reSupplier = this.reSupplier.trim();

                const updatedLog = {
                    id: this.log.id,
                    ...(this.comments && { comments: this.comments }),
                    ...(this.clientCorrected !== this.client && { client: this.clientCorrected }),
                    ...(this.doctorCorrected !== this.doctor && { doctor: this.doctorCorrected }),
                    ...(this.prescriptionCorrected !== this.prescription && {
                        prescription: this.prescriptionCorrected
                    }),
                    ...(this.reSupplier !== this.supplier &&
                        this.reSupplier !== null && this.reSupplier !== '' &&{
                            re_supplier: this.reSupplier
                        })
                };

                await updateLog(this.user.pharmacy_id, updatedLog);
                this.$toastr.s(this.$t('log_updated'));
                this.returnToPreviousPage();
            } catch (error) {
                handleAxiosError(error);
                this.submitClicked = false;
            }
        },
        // handle sign log click action
        handleMarkLogClick(id) {
            this.submitClicked = true;
            this.$bvModal.show('markConfirmationModal'); // show "are you sure?" modal
        },
        // update log and mark it as destroy of package
        async markLogAsDestroyed() {
            try {
                this.comments = this.comments.trim();
                const updatedLog = {
                    id: this.log.id,
                    ...(this.comments && { comments: this.comments }),
                    ...{ mark_destroy: true }
                };

                await updateLog(this.user.pharmacy_id, updatedLog);
                this.$toastr.s(this.$t('log_updated'));
                this.returnToPreviousPage();
            } catch (error) {
                handleAxiosError(error);
                this.submitClicked = false;
            }
        },
        // handle sign log cancel action
        handleMarkLogCancel() {
            this.submitClicked = false;
            this.$bvModal.hide('markConfirmationModal');
        },

    }
};
</script>
